<template>
  <div class="article-box">
    <h5 class="article_title">配资指南</h5>
    <hr>

    <div class="article_content" v-html="data">

      <!--<p>如何注册会员?</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
      <p><br></p>
      <p>第一步：点击官网，点击立即注册</p>
      <p>第二步：填入11位手机号码</p>
      <p>第三步：按提示填入您的用户名&nbsp;</p>
      <p>第四步：按要求填入你要设置的登录密码，请您确认两次设置的密码需一致。&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
      <p>第五步：填入推荐邀请码，如果没有可以不填写&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</p>
      <p>第六步：填入右边显示的验证码&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</p>
      <p>第七步：点击获取手机验证码&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</p>
      <p>第八步：填入你手机短信收到的验证码&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</p>
      <p>第九步：勾选《网站的服务协议》&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</p>
      <p>第十步：点击完成注册</p>
      <p><br></p>
      <p><br></p>
      <p>如何进行充值?</p>
      <p><br></p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p>第一步：点击我的账户</p>
      <p>第二步：填入您注册的手机号码</p>
      <p>第三步：填入您的登入密码</p>
      <p>第四步：填入右边显示的验证码</p>
      <p>第五步：点击登入到您的会员中心</p>
      <p>第六步：点击充值</p>
      <p>第七步：填写您要充值的金额</p>
      <p>第八步：选择您的付款方式</p>
      <p>第九步：点击您要付款的银行</p>
      <p>第十步：点击确认充值</p>
      <p>第十一步：点击您的网银用户名</p>
      <p>第十二步：填写您的网银登录密码</p>
      <p>第十三步：填写右边显示的验证码</p>
      <p>第十四步：插入您的网银u盾，点击下一步</p>
      <p>第十五步：点击支付</p>
      <p>第十六步：填写您网银盾的密码</p>
      <p>第十七步：点击确认</p>
      <p>第十八步：根据图显示，用手按一下您网银盾上的确认按键</p>
      <p>请点击返回支付网站按钮</p>
      <p>恭喜您充值成功，请到您的会员中心查看您的账户明细</p>
      <p><br></p>
      <p><br></p>
      <p><br></p>
      <p>如何申请配资?</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</p>
      <p><br></p>
      <p>第一步：点击我的账户</p>
      <p>第二步：点入您注册的手机号码</p>
      <p>第三步：填入您的登录号码</p>
      <p>第四步：填入右边显示的验证码</p>
      <p>第五步:点击登录到您的会员中心</p>
      <p>第六步：选择您的配资方案</p>
      <p>第七步：点击您要投资的保证金</p>
      <p>第八步：选择您要的放大资金的倍数杠杆</p>
      <p>第九步：选择您要配资的期限</p>
      <p>第十步：选择您开户操盘的时间</p>
      <p>第十一步：点击立即申请</p>
      <p>申请成功，等待开户，可根据提示点击查看详情方案。</p>
      <p>最后交割完后账户中的可用余额申请提现到</p>
      <p><br></p>-->
    </div>
    <!---->


    <!--                    -->
  </div>
</template>

<script>
    export default {
        name: "helpguide",
      data(){
        return{
          data:''
        }
      },
      methods:{
        getData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                'nozzle': 'protocol',
                'type': 13,
              }
            })  .then(res => {
            let resData = res.data;
            if (res.data.code == 1) {
              that.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
        }
      },
      mounted() {
        this.getData();
      }
    }
</script>

<style scoped>
  .article_title{
    font-size: 20px;
    font-weight: 500;
  }
  .article_content>>img{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpguide.vue